const EventsType = [
  {
    id: 0,
    name: 'Event',
    gender: 'all',
    color: '#37b4fb',
  },
  {
    id: 1,
    name: 'Reminder',
    gender: 'all',
    color: '#ff4f4f',
  },
  {
    id: 2,
    name: 'Birthday',
    gender: 'all',
    color: '#9e81f0',
  },
  {
    id: 3,
    name: 'Period',
    gender: 'female',
    color: '#fb87e1',
  },
];

export default EventsType;
